<route-meta>
{
  "requiresAuth": true
}
</route-meta>

<template>
  <div class="extension">
    <header class="detail__header">
      <router-link
        :to="{ name: gridName }"
        class="btn-back"
      >
        <font-awesome-icon icon="chevron-left" />
      </router-link>
      <h1 v-if="object.name">{{ object.name }}</h1>
      <button
        @click="save"
        class="btn btn-success btn--save"
      >
        {{ $t('general.update') }}
      </button>
    </header>

    <div class="extension__form">
      <div class="panel">
        <div class="panel__body">
          <extension-form
            :fields="fields"
            :object="object"
          ></extension-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExtensionForm from './form';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'types-id',
  components: {
    ExtensionForm,
  },
  computed: {
    ...mapGetters('types', {
      fields: 'getFields',
    }),
    ...mapState({
      entries: state => state.types.entries,
    }),
    gridName() {
      return `${this.entity}-index`;
    },
  },
  data() {
    return {
      object: {},
      entity: 'types',
    };
  },
  methods: {
    save() {
      this.$store.dispatch('types/update', {
        object: this.object,
        callback: () => {
          this.$success(this.$t('general.messages.update.success'));
        },
      });
    },
  },
  created() {
    this.$store.dispatch('types/get');
  },
  watch: {
    entries(value) {
      if (value.length === 0) {
        return true;
      }
      const found = value.find(({ _id }) => _id === this.$route.params.id);
      if (typeof found !== 'undefined') {
        this.object = JSON.parse(JSON.stringify(found));
      }
    },
  },
};
</script>
